module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0038.jpg?v=7640044b";